import React from "react";
import { ApprovalRequestStatus } from "../../store/ApprovalCenterStore";
import "./ApprovalStatusBadge.css";

interface ApprovalStatusBadgeProps {
    status: ApprovalRequestStatus;
    className?: string;
    suffix?: string;
}

const statusConfig: Record<ApprovalRequestStatus, { label: string; className: string }> = {
    [ApprovalRequestStatus.Pending]: { label: "Pending Approval", className: "pending" },
    [ApprovalRequestStatus.Approved]: { label: "Approved", className: "approved" },
    [ApprovalRequestStatus.Rejected]: { label: "Rejected", className: "rejected" }
};

export const ApprovalStatusBadge: React.FC<ApprovalStatusBadgeProps> = ({ status, className = "", suffix }) => {
    const config = statusConfig[status];

    if (!config) {
        return null;
    }

    const label = suffix ? `${config.label} (${suffix})` : config.label;
    return (
        <div className={`approval-status-badge ${className}`} title={label}>
            <span className={`approval-status ${config.className}`}>{label}</span>
        </div>
    );
};

export const renderApprovalStatusBadge = (status: ApprovalRequestStatus, className?: string): JSX.Element => {
    return <ApprovalStatusBadge status={status} className={className} />;
};
